import {_request, _requestForm} from "./api";

export const getDocumentStatus = (data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'document/get-status', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};